/* eslint-disable react/prop-types */
import { formatAirportDistance } from "@/utils/locationFormatters.js";

/**
 * NearestAirportSection component for Commercial PDP Location Highlights.
 * Displays the nearest airport to the property with name and distance.
 * Shows empty state when no airport data is available, or error state on fetch failure.
 */
const NearestAirportSection = ({ airport, hasError }) => {
  const renderContent = () => {
    if (hasError) {
      return (
        <p className="location-highlights__error-message">
          Airport information is currently unavailable
        </p>
      );
    }

    if (!airport) {
      return (
        <p className="location-highlights__empty-message">No nearby airports found</p>
      );
    }

    return (
      <div className="location-highlights__section-content">
        <p className="location-highlights__airport-name">{airport.name}</p>
        <p className="location-highlights__airport-distance">
          {formatAirportDistance(airport.distance)}
        </p>
      </div>
    );
  };

  return (
    <div className="location-highlights__section location-highlights__section--airport">
      <div className="location-highlights__section-header">
        <img
          src="/assets/images/pdp/nearestAirport.png"
          alt=""
          aria-hidden="true"
          className="location-highlights__section-icon-img"
        />
        <h4 className="location-highlights__section-title">Nearest Airport</h4>
      </div>
      {renderContent()}
    </div>
  );
};

export default NearestAirportSection;
